module.exports = __webpack_public_path__ + "static/HeroBg-33a65b81d17754e9da3efe628a54cc26.mp4";